export default __webpack_public_path__ + "static/media/bg2mob.18df7f44.jpg";